<template>
  <EditorTabFrame
    :loading="loading"
    :loaded="loaded"
    :load-error="loadError"
    :saving="saving"
    :dirty="isDirty"
    :conflict-message="conflictMessage"
    @save="save"
    @discard="discard"
    @reload="load"
  >
    <div v-if="form">
      <EditorSection title="Regras da doação" description="O que o doador pode fazer no checkout.">
        <EditorSwitch
          v-model="form.donationForTheNextYear"
          label="Parcelas podem passar para o ano seguinte"
          hint="Libera parcelamento em até 12x mesmo perto do fim do ano."
        />
        <EditorSwitch v-model="form.donateToMoreThanOneProduct" label="Permitir doar para mais de um produto na mesma compra" />
        <EditorSwitch :value="form.cpfIsRequired" @input="onCpfRequiredChange" label="Exigir CPF para entrar na campanha" />
        <EditorSwitch v-model="form.permitCnpjDonation" label="Permitir doação por CNPJ" />
        <EditorSwitch v-model="form.memberGetMemberActive" label="Permitir que o doador informe um código de indicação" />
        <EditorSwitch v-model="form.allowUsdDonation" label="Permitir doação em dólar" />
        <EditorSwitch v-model="form.allowMultiplesTicket" label="Permitir doar para mais de um ticket" />
        <EditorSwitch
          v-model="form.useLegacyProductFramework"
          label="Usar a estrutura antiga de produtos (checkout V1)"
          hint="Mantenha desligado, a menos que a campanha dependa do checkout antigo."
        />
      </EditorSection>

      <EditorSection title="Confirmação de dados no login" description="Pede ao doador que revise ou complete o cadastro ao entrar.">
        <EditorSwitch v-model="form.modalConfirmationOnDonationActive" label="Abrir a confirmação de dados ao fazer login" />
        <EditorFieldChecklist
          v-if="form.modalConfirmationOnDonationActive"
          v-model="form.modalConfirmationFields"
          title="Campos pedidos na confirmação"
        />
      </EditorSection>

      <EditorSection title="Checkout simplificado" description="Doação rápida, sem criar conta.">
        <EditorSwitch
          v-model="form.allowAnnonymousDonation"
          label="Ativar o checkout simplificado"
          hint="Ao desligar, os campos do checkout simplificado são desmarcados."
        />
        <EditorFieldChecklist
          v-if="form.allowAnnonymousDonation"
          v-model="form.simplifiedCheckoutFields"
          title="Campos pedidos no checkout simplificado"
        />
        <EditorSwitch v-model="form.checkoutSimplifiedOpenValue" label="Permitir que o doador digite o valor no checkout simplificado" />
      </EditorSection>
    </div>
  </EditorTabFrame>
</template>

<script>
import editorTab from "../editorTab.mixin";
import EditorTabFrame from "../EditorTabFrame.vue";
import EditorSection from "../EditorSection.vue";
import EditorSwitch from "../EditorSwitch.vue";
import EditorFieldChecklist, { emptyFields } from "../EditorFieldChecklist.vue";
import CampaignEditorService from "@/scripts/services/campaignEditor.service";

const service = new CampaignEditorService();

const CPF_NOT_REQUIRED_CONFIRMATION =
  "Você tem certeza que deseja tornar o CPF não requerido? Para isso certifique-se de utilizar como meio de pagamento " +
  "Cartão de Crédito com checkout transparente e recorrência única.";

export default {
  name: "CheckoutTab",
  mixins: [editorTab],
  components: { EditorSection, EditorTabFrame, EditorSwitch, EditorFieldChecklist },
  data() {
    return {
      campaignTypeId: null,
    };
  },
  watch: {
    // Mesma regra do back (e do front antigo): sem doação simplificada, os campos ficam desmarcados.
    "form.allowAnnonymousDonation"(enabled) {
      if (this.form && enabled === false) this.form.simplifiedCheckoutFields = emptyFields();
    },
  },
  methods: {
    fetchSection() {
      return service.getCheckout(this.campaignId);
    },
    saveSection(body) {
      return service.saveCheckout(body);
    },
    toForm(dto) {
      return {
        donationForTheNextYear: !!dto.donationForTheNextYear,
        donateToMoreThanOneProduct: !!dto.donateToMoreThanOneProduct,
        cpfIsRequired: !!dto.cpfIsRequired,
        permitCnpjDonation: !!dto.permitCnpjDonation,
        modalConfirmationOnDonationActive: !!dto.modalConfirmationOnDonationActive,
        modalConfirmationFields: Object.assign(emptyFields(), dto.modalConfirmationFields),
        allowAnnonymousDonation: !!dto.allowAnnonymousDonation,
        simplifiedCheckoutFields: Object.assign(emptyFields(), dto.simplifiedCheckoutFields),
        checkoutSimplifiedOpenValue: !!dto.checkoutSimplifiedOpenValue,
        memberGetMemberActive: !!dto.memberGetMemberActive,
        allowUsdDonation: !!dto.allowUsdDonation,
        useLegacyProductFramework: !!dto.useLegacyProductFramework,
        allowMultiplesTicket: !!dto.allowMultiplesTicket,
      };
    },
    afterLoad(dto) {
      this.campaignTypeId = dto.campaignTypeId;
    },
    onCpfRequiredChange(value) {
      // Na tela antiga, desligar o CPF obrigatório exigia confirmação explícita.
      if (!value && !window.confirm(CPF_NOT_REQUIRED_CONFIRMATION)) {
        this.form.cpfIsRequired = true;
        return;
      }
      this.form.cpfIsRequired = value;
    },
    buildPayload() {
      return Object.assign({}, this.form);
    },
  },
};
</script>
